const s={path:"/api/v1/sessions",method:"POST"},o={path:"/api/v1/sessions/logout",method:"POST"};export{o as Logout,s as RefreshSession};
